/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";
const TatAnalysisReports = () => {
    const embeddedId = "6b6abbda-2f74-4b40-a25f-e6f8527300aa";
    const rsl = [];
    const title = "TAT Analysis Reports";
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default TatAnalysisReports;
